module.exports = __webpack_public_path__ + "img/edg.8d8248f5.svg";